import { render } from "./register_visit.vue?vue&type=template&id=0d4b3618&scoped=true"
import script from "./register_visit.vue?vue&type=script&lang=js"
export * from "./register_visit.vue?vue&type=script&lang=js"

import "./register_visit.vue?vue&type=style&index=0&id=0d4b3618&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4b3618"]])

export default __exports__